function dt(d, p) {
  for (var r = 0; r < p.length; r++) {
    const a = p[r];
    if (typeof a != "string" && !Array.isArray(a)) {
      for (const n in a)
        if (n !== "default" && !(n in d)) {
          const t = Object.getOwnPropertyDescriptor(a, n);
          t && Object.defineProperty(d, n, t.get ? t : {
            enumerable: !0,
            get: () => a[n]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(d, Symbol.toStringTag, { value: "Module" }));
}
var S = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, z = {}, ft = {
  get exports() {
    return z;
  },
  set exports(d) {
    z = d;
  }
}, w = {}, pt = {
  get exports() {
    return w;
  },
  set exports(d) {
    w = d;
  }
}, W = {}, gt = {
  get exports() {
    return W;
  },
  set exports(d) {
    W = d;
  }
}, Q;
function V() {
  return Q || (Q = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r() : p.EvEmitter = r();
    })(typeof window < "u" ? window : S, function() {
      function p() {
      }
      let r = p.prototype;
      return r.on = function(a, n) {
        if (!a || !n)
          return this;
        let t = this._events = this._events || {}, e = t[a] = t[a] || [];
        return e.includes(n) || e.push(n), this;
      }, r.once = function(a, n) {
        if (!a || !n)
          return this;
        this.on(a, n);
        let t = this._onceEvents = this._onceEvents || {}, e = t[a] = t[a] || {};
        return e[n] = !0, this;
      }, r.off = function(a, n) {
        let t = this._events && this._events[a];
        if (!t || !t.length)
          return this;
        let e = t.indexOf(n);
        return e != -1 && t.splice(e, 1), this;
      }, r.emitEvent = function(a, n) {
        let t = this._events && this._events[a];
        if (!t || !t.length)
          return this;
        t = t.slice(0), n = n || [];
        let e = this._onceEvents && this._onceEvents[a];
        for (let o of t)
          e && e[o] && (this.off(a, o), delete e[o]), o.apply(this, n);
        return this;
      }, r.allOff = function() {
        return delete this._events, delete this._onceEvents, this;
      }, p;
    });
  }(gt)), W;
}
var B = {}, mt = {
  get exports() {
    return B;
  },
  set exports(d) {
    B = d;
  }
};
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */
var J;
function ut() {
  return J || (J = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r() : p.getSize = r();
    })(window, function() {
      function r(e) {
        let o = parseFloat(e);
        return e.indexOf("%") == -1 && !isNaN(o) && o;
      }
      let a = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth"
      ];
      function n() {
        let e = {
          width: 0,
          height: 0,
          innerWidth: 0,
          innerHeight: 0,
          outerWidth: 0,
          outerHeight: 0
        };
        return a.forEach((o) => {
          e[o] = 0;
        }), e;
      }
      function t(e) {
        if (typeof e == "string" && (e = document.querySelector(e)), !(e && typeof e == "object" && e.nodeType))
          return;
        let c = getComputedStyle(e);
        if (c.display == "none")
          return n();
        let u = {};
        u.width = e.offsetWidth, u.height = e.offsetHeight;
        let s = u.isBorderBox = c.boxSizing == "border-box";
        a.forEach((A) => {
          let i = c[A], f = parseFloat(i);
          u[A] = isNaN(f) ? 0 : f;
        });
        let h = u.paddingLeft + u.paddingRight, l = u.paddingTop + u.paddingBottom, m = u.marginLeft + u.marginRight, y = u.marginTop + u.marginBottom, g = u.borderLeftWidth + u.borderRightWidth, P = u.borderTopWidth + u.borderBottomWidth, k = r(c.width);
        k !== !1 && (u.width = k + // add padding and border unless it's already including it
        (s ? 0 : h + g));
        let I = r(c.height);
        return I !== !1 && (u.height = I + // add padding and border unless it's already including it
        (s ? 0 : l + P)), u.innerWidth = u.width - (h + g), u.innerHeight = u.height - (l + P), u.outerWidth = u.width + m, u.outerHeight = u.height + y, u;
      }
      return t;
    });
  }(mt)), B;
}
var M = {}, vt = {
  get exports() {
    return M;
  },
  set exports(d) {
    M = d;
  }
}, Y;
function L() {
  return Y || (Y = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(p) : p.fizzyUIUtils = r(p);
    })(S, function(r) {
      let a = {};
      a.extend = function(t, e) {
        return Object.assign(t, e);
      }, a.modulo = function(t, e) {
        return (t % e + e) % e;
      }, a.makeArray = function(t) {
        return Array.isArray(t) ? t : t == null ? [] : typeof t == "object" && typeof t.length == "number" ? [...t] : [t];
      }, a.removeFrom = function(t, e) {
        let o = t.indexOf(e);
        o != -1 && t.splice(o, 1);
      }, a.getParent = function(t, e) {
        for (; t.parentNode && t != document.body; )
          if (t = t.parentNode, t.matches(e))
            return t;
      }, a.getQueryElement = function(t) {
        return typeof t == "string" ? document.querySelector(t) : t;
      }, a.handleEvent = function(t) {
        let e = "on" + t.type;
        this[e] && this[e](t);
      }, a.filterFindElements = function(t, e) {
        return t = a.makeArray(t), t.filter((o) => o instanceof HTMLElement).reduce((o, c) => {
          if (!e)
            return o.push(c), o;
          c.matches(e) && o.push(c);
          let u = c.querySelectorAll(e);
          return o = o.concat(...u), o;
        }, []);
      }, a.debounceMethod = function(t, e, o) {
        o = o || 100;
        let c = t.prototype[e], u = e + "Timeout";
        t.prototype[e] = function() {
          clearTimeout(this[u]);
          let s = arguments;
          this[u] = setTimeout(() => {
            c.apply(this, s), delete this[u];
          }, o);
        };
      }, a.docReady = function(t) {
        let e = document.readyState;
        e == "complete" || e == "interactive" ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t);
      }, a.toDashed = function(t) {
        return t.replace(/(.)([A-Z])/g, function(e, o, c) {
          return o + "-" + c;
        }).toLowerCase();
      };
      let n = r.console;
      return a.htmlInit = function(t, e) {
        a.docReady(function() {
          let c = "data-" + a.toDashed(e), u = document.querySelectorAll(`[${c}]`), s = r.jQuery;
          [...u].forEach((h) => {
            let l = h.getAttribute(c), m;
            try {
              m = l && JSON.parse(l);
            } catch (g) {
              n && n.error(`Error parsing ${c} on ${h.className}: ${g}`);
              return;
            }
            let y = new t(h, m);
            s && s.data(h, e, y);
          });
        });
      }, a;
    });
  }(vt)), M;
}
var _ = {}, yt = {
  get exports() {
    return _;
  },
  set exports(d) {
    _ = d;
  }
}, Z;
function Et() {
  return Z || (Z = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(ut()) : (p.Flickity = p.Flickity || {}, p.Flickity.Cell = r(p.getSize));
    })(typeof window < "u" ? window : S, function(r) {
      const a = "flickity-cell";
      function n(e) {
        this.element = e, this.element.classList.add(a), this.x = 0, this.unselect();
      }
      let t = n.prototype;
      return t.destroy = function() {
        this.unselect(), this.element.classList.remove(a), this.element.style.transform = "", this.element.removeAttribute("aria-hidden");
      }, t.getSize = function() {
        this.size = r(this.element);
      }, t.select = function() {
        this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden");
      }, t.unselect = function() {
        this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true");
      }, t.remove = function() {
        this.element.remove();
      }, n;
    });
  }(yt)), _;
}
var T = {}, xt = {
  get exports() {
    return T;
  },
  set exports(d) {
    T = d;
  }
}, K;
function Ct() {
  return K || (K = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r() : (p.Flickity = p.Flickity || {}, p.Flickity.Slide = r());
    })(typeof window < "u" ? window : S, function() {
      function r(n, t, e) {
        this.beginMargin = n, this.endMargin = t, this.cellAlign = e, this.cells = [], this.outerWidth = 0, this.height = 0;
      }
      let a = r.prototype;
      return a.addCell = function(n) {
        this.cells.push(n), this.outerWidth += n.size.outerWidth, this.height = Math.max(n.size.outerHeight, this.height), this.cells.length === 1 && (this.x = n.x, this.firstMargin = n.size[this.beginMargin]);
      }, a.updateTarget = function() {
        let n = this.getLastCell(), t = n ? n.size[this.endMargin] : 0, e = this.outerWidth - (this.firstMargin + t);
        this.target = this.x + this.firstMargin + e * this.cellAlign;
      }, a.getLastCell = function() {
        return this.cells[this.cells.length - 1];
      }, a.select = function() {
        this.cells.forEach((n) => n.select());
      }, a.unselect = function() {
        this.cells.forEach((n) => n.unselect());
      }, a.getCellElements = function() {
        return this.cells.map((n) => n.element);
      }, r;
    });
  }(xt)), T;
}
var q = {}, St = {
  get exports() {
    return q;
  },
  set exports(d) {
    q = d;
  }
}, tt;
function bt() {
  return tt || (tt = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(L()) : (p.Flickity = p.Flickity || {}, p.Flickity.animatePrototype = r(p.fizzyUIUtils));
    })(typeof window < "u" ? window : S, function(r) {
      let a = {};
      return a.startAnimation = function() {
        this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate());
      }, a.animate = function() {
        this.applyDragForce(), this.applySelectedAttraction();
        let n = this.x;
        this.integratePhysics(), this.positionSlider(), this.settle(n), this.isAnimating && requestAnimationFrame(() => this.animate());
      }, a.positionSlider = function() {
        let n = this.x;
        this.isWrapping && (n = r.modulo(n, this.slideableWidth) - this.slideableWidth, this.shiftWrapCells(n)), this.setTranslateX(n, this.isAnimating), this.dispatchScrollEvent();
      }, a.setTranslateX = function(n, t) {
        n += this.cursorPosition, this.options.rightToLeft && (n = -n);
        let e = this.getPositionValue(n);
        this.slider.style.transform = t ? `translate3d(${e},0,0)` : `translateX(${e})`;
      }, a.dispatchScrollEvent = function() {
        let n = this.slides[0];
        if (!n)
          return;
        let t = -this.x - n.target, e = t / this.slidesWidth;
        this.dispatchEvent("scroll", null, [e, t]);
      }, a.positionSliderAtSelected = function() {
        this.cells.length && (this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider());
      }, a.getPositionValue = function(n) {
        return this.options.percentPosition ? Math.round(n / this.size.innerWidth * 1e4) * 0.01 + "%" : Math.round(n) + "px";
      }, a.settle = function(n) {
        !this.isPointerDown && Math.round(this.x * 100) === Math.round(n * 100) && this.restingFrames++, this.restingFrames > 2 && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]));
      }, a.shiftWrapCells = function(n) {
        let t = this.cursorPosition + n;
        this._shiftCells(this.beforeShiftCells, t, -1);
        let e = this.size.innerWidth - (n + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, e, 1);
      }, a._shiftCells = function(n, t, e) {
        n.forEach((o) => {
          let c = t > 0 ? e : 0;
          this._wrapShiftCell(o, c), t -= o.size.outerWidth;
        });
      }, a._unshiftCells = function(n) {
        !n || !n.length || n.forEach((t) => this._wrapShiftCell(t, 0));
      }, a._wrapShiftCell = function(n, t) {
        this._renderCellPosition(n, n.x + this.slideableWidth * t);
      }, a.integratePhysics = function() {
        this.x += this.velocity, this.velocity *= this.getFrictionFactor();
      }, a.applyForce = function(n) {
        this.velocity += n;
      }, a.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
      }, a.getRestingPosition = function() {
        return this.x + this.velocity / (1 - this.getFrictionFactor());
      }, a.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown)
          return;
        let t = this.dragX - this.x - this.velocity;
        this.applyForce(t);
      }, a.applySelectedAttraction = function() {
        if (this.isDraggable && this.isPointerDown || this.isFreeScrolling || !this.slides.length)
          return;
        let e = (this.selectedSlide.target * -1 - this.x) * this.options.selectedAttraction;
        this.applyForce(e);
      }, a;
    });
  }(St)), q;
}
var et;
function D() {
  return et || (et = 1, function(d) {
    (function(p, r) {
      if (d.exports)
        d.exports = r(
          p,
          V(),
          ut(),
          L(),
          Et(),
          Ct(),
          bt()
        );
      else {
        let a = p.Flickity;
        p.Flickity = r(
          p,
          p.EvEmitter,
          p.getSize,
          p.fizzyUIUtils,
          a.Cell,
          a.Slide,
          a.animatePrototype
        );
      }
    })(
      typeof window < "u" ? window : S,
      function(r, a, n, t, e, o, c) {
        const { getComputedStyle: u, console: s } = r;
        let { jQuery: h } = r, l = 0, m = {};
        function y(i, f) {
          let v = t.getQueryElement(i);
          if (!v) {
            s && s.error(`Bad element for Flickity: ${v || i}`);
            return;
          }
          if (this.element = v, this.element.flickityGUID) {
            let E = m[this.element.flickityGUID];
            return E && E.option(f), E;
          }
          h && (this.$element = h(this.element)), this.options = { ...this.constructor.defaults }, this.option(f), this._create();
        }
        y.defaults = {
          accessibility: !0,
          // adaptiveHeight: false,
          cellAlign: "center",
          // cellSelector: undefined,
          // contain: false,
          freeScrollFriction: 0.075,
          // friction when free-scrolling
          friction: 0.28,
          // friction when selecting
          namespaceJQueryEvents: !0,
          // initialIndex: 0,
          percentPosition: !0,
          resize: !0,
          selectedAttraction: 0.025,
          setGallerySize: !0
          // watchCSS: false,
          // wrapAround: false
        }, y.create = {};
        let g = y.prototype;
        Object.assign(g, a.prototype), g._create = function() {
          let { resize: i, watchCSS: f, rightToLeft: v } = this.options, E = this.guid = ++l;
          this.element.flickityGUID = E, m[E] = this, this.selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.beginMargin = v ? "marginRight" : "marginLeft", this.endMargin = v ? "marginLeft" : "marginRight", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", this._createSlider(), this.focusableElems = [this.element], (i || f) && r.addEventListener("resize", this);
          for (let x in this.options.on) {
            let C = this.options.on[x];
            this.on(x, C);
          }
          for (let x in y.create)
            y.create[x].call(this);
          f ? this.watchCSS() : this.activate();
        }, g.option = function(i) {
          Object.assign(this.options, i);
        }, g.activate = function() {
          if (this.isActive)
            return;
          this.isActive = !0, this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize();
          let i = this._filterFindCellElements(this.element.children);
          this.slider.append(...i), this.viewport.append(this.slider), this.element.append(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, this.element.addEventListener("keydown", this)), this.emitEvent("activate"), this.selectInitialIndex(), this.isInitActivated = !0, this.dispatchEvent("ready");
        }, g._createSlider = function() {
          let i = document.createElement("div");
          i.className = "flickity-slider", this.slider = i;
        }, g._filterFindCellElements = function(i) {
          return t.filterFindElements(i, this.options.cellSelector);
        }, g.reloadCells = function() {
          this.cells = this._makeCells(this.slider.children), this.positionCells(), this._updateWrapShiftCells(), this.setGallerySize();
        }, g._makeCells = function(i) {
          return this._filterFindCellElements(i).map((v) => new e(v));
        }, g.getLastCell = function() {
          return this.cells[this.cells.length - 1];
        }, g.getLastSlide = function() {
          return this.slides[this.slides.length - 1];
        }, g.positionCells = function() {
          this._sizeCells(this.cells), this._positionCells(0);
        }, g._positionCells = function(i) {
          i = i || 0, this.maxCellHeight = i && this.maxCellHeight || 0;
          let f = 0;
          if (i > 0) {
            let v = this.cells[i - 1];
            f = v.x + v.size.outerWidth;
          }
          this.cells.slice(i).forEach((v) => {
            v.x = f, this._renderCellPosition(v, f), f += v.size.outerWidth, this.maxCellHeight = Math.max(v.size.outerHeight, this.maxCellHeight);
          }), this.slideableWidth = f, this.updateSlides(), this._containSlides(), this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
        }, g._renderCellPosition = function(i, f) {
          let v = this.options.rightToLeft ? -1 : 1, E = f * v;
          this.options.percentPosition && (E *= this.size.innerWidth / i.size.width);
          let x = this.getPositionValue(E);
          i.element.style.transform = `translateX( ${x} )`;
        }, g._sizeCells = function(i) {
          i.forEach((f) => f.getSize());
        }, g.updateSlides = function() {
          if (this.slides = [], !this.cells.length)
            return;
          let { beginMargin: i, endMargin: f } = this, v = new o(i, f, this.cellAlign);
          this.slides.push(v);
          let E = this._getCanCellFit();
          this.cells.forEach((x, C) => {
            if (!v.cells.length) {
              v.addCell(x);
              return;
            }
            let b = v.outerWidth - v.firstMargin + (x.size.outerWidth - x.size[f]);
            E(C, b) || (v.updateTarget(), v = new o(i, f, this.cellAlign), this.slides.push(v)), v.addCell(x);
          }), v.updateTarget(), this.updateSelectedSlide();
        }, g._getCanCellFit = function() {
          let { groupCells: i } = this.options;
          if (!i)
            return () => !1;
          if (typeof i == "number") {
            let x = parseInt(i, 10);
            return (C) => C % x !== 0;
          }
          let f = 1, v = typeof i == "string" && i.match(/^(\d+)%$/);
          v && (f = parseInt(v[1], 10) / 100);
          let E = (this.size.innerWidth + 1) * f;
          return (x, C) => C <= E;
        }, g._init = g.reposition = function() {
          this.positionCells(), this.positionSliderAtSelected();
        }, g.getSize = function() {
          this.size = n(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign;
        };
        let P = {
          left: 0,
          center: 0.5,
          right: 1
        };
        g.setCellAlign = function() {
          let { cellAlign: i, rightToLeft: f } = this.options, v = P[i];
          this.cellAlign = v !== void 0 ? v : i, f && (this.cellAlign = 1 - this.cellAlign);
        }, g.setGallerySize = function() {
          if (!this.options.setGallerySize)
            return;
          let i = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
          this.viewport.style.height = `${i}px`;
        }, g._updateWrapShiftCells = function() {
          if (this.isWrapping = this.getIsWrapping(), !this.isWrapping)
            return;
          this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
          let i = this.cursorPosition, f = this.cells.length - 1;
          this.beforeShiftCells = this._getGapCells(i, f, -1);
          let v = this.size.innerWidth - this.cursorPosition;
          this.afterShiftCells = this._getGapCells(v, 0, 1);
        }, g.getIsWrapping = function() {
          let { wrapAround: i } = this.options;
          if (!i || this.slides.length < 2)
            return !1;
          if (i !== "fill")
            return !0;
          let f = this.slideableWidth - this.size.innerWidth;
          if (f > this.size.innerWidth)
            return !0;
          for (let v of this.cells)
            if (v.size.outerWidth > f)
              return !1;
          return !0;
        }, g._getGapCells = function(i, f, v) {
          let E = [];
          for (; i > 0; ) {
            let x = this.cells[f];
            if (!x)
              break;
            E.push(x), f += v, i -= x.size.outerWidth;
          }
          return E;
        }, g._containSlides = function() {
          if (!(this.options.contain && !this.isWrapping && this.cells.length))
            return;
          let f = this.slideableWidth - this.getLastCell().size[this.endMargin];
          if (f < this.size.innerWidth)
            this.slides.forEach((E) => {
              E.target = f * this.cellAlign;
            });
          else {
            let E = this.cursorPosition + this.cells[0].size[this.beginMargin], x = f - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach((C) => {
              C.target = Math.max(C.target, E), C.target = Math.min(C.target, x);
            });
          }
        }, g.dispatchEvent = function(i, f, v) {
          let E = f ? [f].concat(v) : v;
          if (this.emitEvent(i, E), h && this.$element) {
            i += this.options.namespaceJQueryEvents ? ".flickity" : "";
            let x = i;
            if (f) {
              let C = new h.Event(f);
              C.type = i, x = C;
            }
            this.$element.trigger(x, v);
          }
        };
        const k = [
          "dragStart",
          "dragMove",
          "dragEnd",
          "pointerDown",
          "pointerMove",
          "pointerEnd",
          "staticClick"
        ];
        let I = g.emitEvent;
        g.emitEvent = function(i, f) {
          if (i === "staticClick") {
            let C = this.getParentCell(f[0].target), b = C && C.element, G = C && this.cells.indexOf(C);
            f = f.concat(b, G);
          }
          if (I.call(this, i, f), !k.includes(i) || !h || !this.$element)
            return;
          i += this.options.namespaceJQueryEvents ? ".flickity" : "";
          let E = f.shift(0), x = new h.Event(E);
          x.type = i, this.$element.trigger(x, f);
        }, g.select = function(i, f, v) {
          if (!this.isActive || (i = parseInt(i, 10), this._wrapSelect(i), (this.isWrapping || f) && (i = t.modulo(i, this.slides.length)), !this.slides[i]))
            return;
          let E = this.selectedIndex;
          this.selectedIndex = i, this.updateSelectedSlide(), v ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select", null, [i]), i !== E && this.dispatchEvent("change", null, [i]);
        }, g._wrapSelect = function(i) {
          if (!this.isWrapping)
            return;
          const { selectedIndex: f, slideableWidth: v, slides: { length: E } } = this;
          if (!this.isDragSelect) {
            let x = t.modulo(i, E), C = Math.abs(x - f), b = Math.abs(x + E - f), G = Math.abs(x - E - f);
            b < C ? i += E : G < C && (i -= E);
          }
          i < 0 ? this.x -= v : i >= E && (this.x += v);
        }, g.previous = function(i, f) {
          this.select(this.selectedIndex - 1, i, f);
        }, g.next = function(i, f) {
          this.select(this.selectedIndex + 1, i, f);
        }, g.updateSelectedSlide = function() {
          let i = this.slides[this.selectedIndex];
          i && (this.unselectSelectedSlide(), this.selectedSlide = i, i.select(), this.selectedCells = i.cells, this.selectedElements = i.getCellElements(), this.selectedCell = i.cells[0], this.selectedElement = this.selectedElements[0]);
        }, g.unselectSelectedSlide = function() {
          this.selectedSlide && this.selectedSlide.unselect();
        }, g.selectInitialIndex = function() {
          let i = this.options.initialIndex;
          if (this.isInitActivated) {
            this.select(this.selectedIndex, !1, !0);
            return;
          }
          if (i && typeof i == "string" && this.queryCell(i)) {
            this.selectCell(i, !1, !0);
            return;
          }
          let f = 0;
          i && this.slides[i] && (f = i), this.select(f, !1, !0);
        }, g.selectCell = function(i, f, v) {
          let E = this.queryCell(i);
          if (!E)
            return;
          let x = this.getCellSlideIndex(E);
          this.select(x, f, v);
        }, g.getCellSlideIndex = function(i) {
          let f = this.slides.find((v) => v.cells.includes(i));
          return this.slides.indexOf(f);
        }, g.getCell = function(i) {
          for (let f of this.cells)
            if (f.element === i)
              return f;
        }, g.getCells = function(i) {
          return i = t.makeArray(i), i.map((f) => this.getCell(f)).filter(Boolean);
        }, g.getCellElements = function() {
          return this.cells.map((i) => i.element);
        }, g.getParentCell = function(i) {
          let f = this.getCell(i);
          if (f)
            return f;
          let v = i.closest(".flickity-slider > *");
          return this.getCell(v);
        }, g.getAdjacentCellElements = function(i, f) {
          if (!i)
            return this.selectedSlide.getCellElements();
          f = f === void 0 ? this.selectedIndex : f;
          let v = this.slides.length;
          if (1 + i * 2 >= v)
            return this.getCellElements();
          let E = [];
          for (let x = f - i; x <= f + i; x++) {
            let C = this.isWrapping ? t.modulo(x, v) : x, b = this.slides[C];
            b && (E = E.concat(b.getCellElements()));
          }
          return E;
        }, g.queryCell = function(i) {
          return typeof i == "number" ? this.cells[i] : (typeof i == "string" && !i.match(/^[#.]?[\d/]/) && (i = this.element.querySelector(i)), this.getCell(i));
        }, g.uiChange = function() {
          this.emitEvent("uiChange");
        }, g.onresize = function() {
          this.watchCSS(), this.resize();
        }, t.debounceMethod(y, "onresize", 150), g.resize = function() {
          if (!this.isActive || this.isAnimating || this.isDragging)
            return;
          this.getSize(), this.isWrapping && (this.x = t.modulo(this.x, this.slideableWidth)), this.positionCells(), this._updateWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
          let i = this.selectedElements && this.selectedElements[0];
          this.selectCell(i, !1, !0);
        }, g.watchCSS = function() {
          if (!this.options.watchCSS)
            return;
          u(this.element, ":after").content.includes("flickity") ? this.activate() : this.deactivate();
        }, g.onkeydown = function(i) {
          let { activeElement: f } = document, v = y.keyboardHandlers[i.key];
          if (!this.options.accessibility || !f || !v)
            return;
          this.focusableElems.some((x) => f === x) && v.call(this);
        }, y.keyboardHandlers = {
          ArrowLeft: function() {
            this.uiChange();
            let i = this.options.rightToLeft ? "next" : "previous";
            this[i]();
          },
          ArrowRight: function() {
            this.uiChange();
            let i = this.options.rightToLeft ? "previous" : "next";
            this[i]();
          }
        }, g.focus = function() {
          this.element.focus({ preventScroll: !0 });
        }, g.deactivate = function() {
          this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), this.unselectSelectedSlide(), this.cells.forEach((i) => i.destroy()), this.viewport.remove(), this.element.append(...this.slider.children), this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), this.isActive = !1, this.emitEvent("deactivate"));
        }, g.destroy = function() {
          this.deactivate(), r.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), h && this.$element && h.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete m[this.guid];
        }, Object.assign(g, c), y.data = function(i) {
          if (i = t.getQueryElement(i), i)
            return m[i.flickityGUID];
        }, t.htmlInit(y, "flickity");
        let { jQueryBridget: A } = r;
        return h && A && A("flickity", y, h), y.setJQuery = function(i) {
          h = i;
        }, y.Cell = e, y.Slide = o, y;
      }
    );
  }(pt)), w;
}
var F = {}, Dt = {
  get exports() {
    return F;
  },
  set exports(d) {
    F = d;
  }
}, O = {}, Pt = {
  get exports() {
    return O;
  },
  set exports(d) {
    O = d;
  }
};
/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */
var it;
function Lt() {
  return it || (it = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(
        p,
        V()
      ) : p.Unidragger = r(
        p,
        p.EvEmitter
      );
    })(typeof window < "u" ? window : S, function(r, a) {
      function n() {
      }
      let t = n.prototype = Object.create(a.prototype);
      t.handleEvent = function(s) {
        let h = "on" + s.type;
        this[h] && this[h](s);
      };
      let e, o;
      "ontouchstart" in r ? (e = "touchstart", o = ["touchmove", "touchend", "touchcancel"]) : r.PointerEvent ? (e = "pointerdown", o = ["pointermove", "pointerup", "pointercancel"]) : (e = "mousedown", o = ["mousemove", "mouseup"]), t.touchActionValue = "none", t.bindHandles = function() {
        this._bindHandles("addEventListener", this.touchActionValue);
      }, t.unbindHandles = function() {
        this._bindHandles("removeEventListener", "");
      }, t._bindHandles = function(s, h) {
        this.handles.forEach((l) => {
          l[s](e, this), l[s]("click", this), r.PointerEvent && (l.style.touchAction = h);
        });
      }, t.bindActivePointerEvents = function() {
        o.forEach((s) => {
          r.addEventListener(s, this);
        });
      }, t.unbindActivePointerEvents = function() {
        o.forEach((s) => {
          r.removeEventListener(s, this);
        });
      }, t.withPointer = function(s, h) {
        h.pointerId === this.pointerIdentifier && this[s](h, h);
      }, t.withTouch = function(s, h) {
        let l;
        for (let m of h.changedTouches)
          m.identifier === this.pointerIdentifier && (l = m);
        l && this[s](h, l);
      }, t.onmousedown = function(s) {
        this.pointerDown(s, s);
      }, t.ontouchstart = function(s) {
        this.pointerDown(s, s.changedTouches[0]);
      }, t.onpointerdown = function(s) {
        this.pointerDown(s, s);
      };
      const c = ["TEXTAREA", "INPUT", "SELECT", "OPTION"], u = ["radio", "checkbox", "button", "submit", "image", "file"];
      return t.pointerDown = function(s, h) {
        let l = c.includes(s.target.nodeName), m = u.includes(s.target.type), y = !l || m;
        !this.isPointerDown && !s.button && y && (this.isPointerDown = !0, this.pointerIdentifier = h.pointerId !== void 0 ? (
          // pointerId for pointer events, touch.indentifier for touch events
          h.pointerId
        ) : h.identifier, this.pointerDownPointer = {
          pageX: h.pageX,
          pageY: h.pageY
        }, this.bindActivePointerEvents(), this.emitEvent("pointerDown", [s, h]));
      }, t.onmousemove = function(s) {
        this.pointerMove(s, s);
      }, t.onpointermove = function(s) {
        this.withPointer("pointerMove", s);
      }, t.ontouchmove = function(s) {
        this.withTouch("pointerMove", s);
      }, t.pointerMove = function(s, h) {
        let l = {
          x: h.pageX - this.pointerDownPointer.pageX,
          y: h.pageY - this.pointerDownPointer.pageY
        };
        this.emitEvent("pointerMove", [s, h, l]), !this.isDragging && this.hasDragStarted(l) && this.dragStart(s, h), this.isDragging && this.dragMove(s, h, l);
      }, t.hasDragStarted = function(s) {
        return Math.abs(s.x) > 3 || Math.abs(s.y) > 3;
      }, t.dragStart = function(s, h) {
        this.isDragging = !0, this.isPreventingClicks = !0, this.emitEvent("dragStart", [s, h]);
      }, t.dragMove = function(s, h, l) {
        this.emitEvent("dragMove", [s, h, l]);
      }, t.onmouseup = function(s) {
        this.pointerUp(s, s);
      }, t.onpointerup = function(s) {
        this.withPointer("pointerUp", s);
      }, t.ontouchend = function(s) {
        this.withTouch("pointerUp", s);
      }, t.pointerUp = function(s, h) {
        this.pointerDone(), this.emitEvent("pointerUp", [s, h]), this.isDragging ? this.dragEnd(s, h) : this.staticClick(s, h);
      }, t.dragEnd = function(s, h) {
        this.isDragging = !1, setTimeout(() => delete this.isPreventingClicks), this.emitEvent("dragEnd", [s, h]);
      }, t.pointerDone = function() {
        this.isPointerDown = !1, delete this.pointerIdentifier, this.unbindActivePointerEvents(), this.emitEvent("pointerDone");
      }, t.onpointercancel = function(s) {
        this.withPointer("pointerCancel", s);
      }, t.ontouchcancel = function(s) {
        this.withTouch("pointerCancel", s);
      }, t.pointerCancel = function(s, h) {
        this.pointerDone(), this.emitEvent("pointerCancel", [s, h]);
      }, t.onclick = function(s) {
        this.isPreventingClicks && s.preventDefault();
      }, t.staticClick = function(s, h) {
        let l = s.type === "mouseup";
        l && this.isIgnoringMouseUp || (this.emitEvent("staticClick", [s, h]), l && (this.isIgnoringMouseUp = !0, setTimeout(() => {
          delete this.isIgnoringMouseUp;
        }, 400)));
      }, n;
    });
  }(Pt)), O;
}
var st;
function At() {
  return st || (st = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(
        p,
        D(),
        Lt(),
        L()
      ) : p.Flickity = r(
        p,
        p.Flickity,
        p.Unidragger,
        p.fizzyUIUtils
      );
    })(
      typeof window < "u" ? window : S,
      function(r, a, n, t) {
        Object.assign(a.defaults, {
          draggable: ">1",
          dragThreshold: 3
        });
        let e = a.prototype;
        Object.assign(e, n.prototype), e.touchActionValue = "", a.create.drag = function() {
          this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable), this.on("pointerDown", this.handlePointerDown), this.on("pointerUp", this.handlePointerUp), this.on("pointerDown", this.handlePointerDone), this.on("dragStart", this.handleDragStart), this.on("dragMove", this.handleDragMove), this.on("dragEnd", this.handleDragEnd), this.on("staticClick", this.handleStaticClick);
        }, e.onActivateDrag = function() {
          this.handles = [this.viewport], this.bindHandles(), this.updateDraggable();
        }, e.onDeactivateDrag = function() {
          this.unbindHandles(), this.element.classList.remove("is-draggable");
        }, e.updateDraggable = function() {
          this.options.draggable === ">1" ? this.isDraggable = this.slides.length > 1 : this.isDraggable = this.options.draggable, this.element.classList.toggle("is-draggable", this.isDraggable);
        }, e._uiChangeDrag = function() {
          delete this.isFreeScrolling;
        }, e.handlePointerDown = function(c) {
          if (!this.isDraggable) {
            this.bindActivePointerEvents(c);
            return;
          }
          let u = c.type === "touchstart", s = c.pointerType === "touch", h = c.target.matches("input, textarea, select");
          !u && !s && !h && c.preventDefault(), h || this.focus(), document.activeElement !== this.element && document.activeElement.blur(), this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this.pointerDownScroll = o(), r.addEventListener("scroll", this), this.bindActivePointerEvents(c);
        }, e.hasDragStarted = function(c) {
          return Math.abs(c.x) > this.options.dragThreshold;
        }, e.handlePointerUp = function() {
          delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down");
        }, e.handlePointerDone = function() {
          r.removeEventListener("scroll", this), delete this.pointerDownScroll;
        }, e.handleDragStart = function() {
          this.isDraggable && (this.dragStartPosition = this.x, this.startAnimation(), r.removeEventListener("scroll", this));
        }, e.handleDragMove = function(c, u, s) {
          if (!this.isDraggable)
            return;
          c.preventDefault(), this.previousDragX = this.dragX;
          let h = this.options.rightToLeft ? -1 : 1;
          this.isWrapping && (s.x %= this.slideableWidth);
          let l = this.dragStartPosition + s.x * h;
          if (!this.isWrapping) {
            let m = Math.max(-this.slides[0].target, this.dragStartPosition);
            l = l > m ? (l + m) * 0.5 : l;
            let y = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            l = l < y ? (l + y) * 0.5 : l;
          }
          this.dragX = l, this.dragMoveTime = /* @__PURE__ */ new Date();
        }, e.handleDragEnd = function() {
          if (!this.isDraggable)
            return;
          let { freeScroll: c } = this.options;
          c && (this.isFreeScrolling = !0);
          let u = this.dragEndRestingSelect();
          if (c && !this.isWrapping) {
            let s = this.getRestingPosition();
            this.isFreeScrolling = -s > this.slides[0].target && -s < this.getLastSlide().target;
          } else
            !c && u === this.selectedIndex && (u += this.dragEndBoostSelect());
          delete this.previousDragX, this.isDragSelect = this.isWrapping, this.select(u), delete this.isDragSelect;
        }, e.dragEndRestingSelect = function() {
          let c = this.getRestingPosition(), u = Math.abs(this.getSlideDistance(-c, this.selectedIndex)), s = this._getClosestResting(c, u, 1), h = this._getClosestResting(c, u, -1);
          return s.distance < h.distance ? s.index : h.index;
        }, e._getClosestResting = function(c, u, s) {
          let h = this.selectedIndex, l = 1 / 0, m = this.options.contain && !this.isWrapping ? (
            // if containing, keep going if distance is equal to minDistance
            (y, g) => y <= g
          ) : (y, g) => y < g;
          for (; m(u, l) && (h += s, l = u, u = this.getSlideDistance(-c, h), u !== null); )
            u = Math.abs(u);
          return {
            distance: l,
            // selected was previous index
            index: h - s
          };
        }, e.getSlideDistance = function(c, u) {
          let s = this.slides.length, h = this.options.wrapAround && s > 1, l = h ? t.modulo(u, s) : u, m = this.slides[l];
          if (!m)
            return null;
          let y = h ? this.slideableWidth * Math.floor(u / s) : 0;
          return c - (m.target + y);
        }, e.dragEndBoostSelect = function() {
          if (this.previousDragX === void 0 || !this.dragMoveTime || // or if drag was held for 100 ms
          /* @__PURE__ */ new Date() - this.dragMoveTime > 100)
            return 0;
          let c = this.getSlideDistance(-this.dragX, this.selectedIndex), u = this.previousDragX - this.dragX;
          return c > 0 && u > 0 ? 1 : c < 0 && u < 0 ? -1 : 0;
        }, e.onscroll = function() {
          let c = o(), u = this.pointerDownScroll.x - c.x, s = this.pointerDownScroll.y - c.y;
          (Math.abs(u) > 3 || Math.abs(s) > 3) && this.pointerDone();
        };
        function o() {
          return {
            x: r.pageXOffset,
            y: r.pageYOffset
          };
        }
        return a;
      }
    );
  }(Dt)), F;
}
var R = {}, kt = {
  get exports() {
    return R;
  },
  set exports(d) {
    R = d;
  }
}, nt;
function It() {
  return nt || (nt = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(D()) : r(p.Flickity);
    })(typeof window < "u" ? window : S, function(r) {
      const a = "http://www.w3.org/2000/svg";
      function n(o, c, u) {
        this.increment = o, this.direction = c, this.isPrevious = o === "previous", this.isLeft = c === "left", this._create(u);
      }
      n.prototype._create = function(o) {
        let c = this.element = document.createElement("button");
        c.className = `flickity-button flickity-prev-next-button ${this.increment}`;
        let u = this.isPrevious ? "Previous" : "Next";
        c.setAttribute("type", "button"), c.setAttribute("aria-label", u), this.disable();
        let s = this.createSVG(u, o);
        c.append(s);
      }, n.prototype.createSVG = function(o, c) {
        let u = document.createElementNS(a, "svg");
        u.setAttribute("class", "flickity-button-icon"), u.setAttribute("viewBox", "0 0 100 100");
        let s = document.createElementNS(a, "title");
        s.append(o);
        let h = document.createElementNS(a, "path"), l = t(c);
        return h.setAttribute("d", l), h.setAttribute("class", "arrow"), this.isLeft || h.setAttribute("transform", "translate(100, 100) rotate(180)"), u.append(s, h), u;
      };
      function t(o) {
        if (typeof o == "string")
          return o;
        let { x0: c, x1: u, x2: s, x3: h, y1: l, y2: m } = o;
        return `M ${c}, 50
    L ${u}, ${l + 50}
    L ${s}, ${m + 50}
    L ${h}, 50
    L ${s}, ${50 - m}
    L ${u}, ${50 - l}
    Z`;
      }
      n.prototype.enable = function() {
        this.element.removeAttribute("disabled");
      }, n.prototype.disable = function() {
        this.element.setAttribute("disabled", !0);
      }, Object.assign(r.defaults, {
        prevNextButtons: !0,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 70,
          y2: 40,
          x3: 30
        }
      }), r.create.prevNextButtons = function() {
        if (!this.options.prevNextButtons)
          return;
        let { rightToLeft: o, arrowShape: c } = this.options, u = o ? "right" : "left", s = o ? "left" : "right";
        this.prevButton = new n("previous", u, c), this.nextButton = new n("next", s, c), this.focusableElems.push(this.prevButton.element), this.focusableElems.push(this.nextButton.element), this.handlePrevButtonClick = () => {
          this.uiChange(), this.previous();
        }, this.handleNextButtonClick = () => {
          this.uiChange(), this.next();
        }, this.on("activate", this.activatePrevNextButtons), this.on("select", this.updatePrevNextButtons);
      };
      let e = r.prototype;
      return e.updatePrevNextButtons = function() {
        let o = this.slides.length ? this.slides.length - 1 : 0;
        this.updatePrevNextButton(this.prevButton, 0), this.updatePrevNextButton(this.nextButton, o);
      }, e.updatePrevNextButton = function(o, c) {
        if (this.isWrapping && this.slides.length > 1) {
          o.enable();
          return;
        }
        let u = this.selectedIndex !== c;
        o[u ? "enable" : "disable"](), !u && document.activeElement === o.element && this.focus();
      }, e.activatePrevNextButtons = function() {
        this.prevButton.element.addEventListener("click", this.handlePrevButtonClick), this.nextButton.element.addEventListener("click", this.handleNextButtonClick), this.element.append(this.prevButton.element, this.nextButton.element), this.on("deactivate", this.deactivatePrevNextButtons);
      }, e.deactivatePrevNextButtons = function() {
        this.prevButton.element.remove(), this.nextButton.element.remove(), this.prevButton.element.removeEventListener("click", this.handlePrevButtonClick), this.nextButton.element.removeEventListener("click", this.handleNextButtonClick), this.off("deactivate", this.deactivatePrevNextButtons);
      }, r.PrevNextButton = n, r;
    });
  }(kt)), R;
}
var N = {}, zt = {
  get exports() {
    return N;
  },
  set exports(d) {
    N = d;
  }
}, rt;
function wt() {
  return rt || (rt = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(
        D(),
        L()
      ) : r(
        p.Flickity,
        p.fizzyUIUtils
      );
    })(typeof window < "u" ? window : S, function(r, a) {
      function n() {
        this.holder = document.createElement("div"), this.holder.className = "flickity-page-dots", this.dots = [];
      }
      n.prototype.setDots = function(e) {
        let o = e - this.dots.length;
        o > 0 ? this.addDots(o) : o < 0 && this.removeDots(-o);
      }, n.prototype.addDots = function(e) {
        let o = new Array(e).fill().map((c, u) => {
          let s = document.createElement("button");
          s.setAttribute("type", "button");
          let h = u + 1 + this.dots.length;
          return s.className = "flickity-page-dot", s.textContent = `View slide ${h}`, s;
        });
        this.holder.append(...o), this.dots = this.dots.concat(o);
      }, n.prototype.removeDots = function(e) {
        this.dots.splice(this.dots.length - e, e).forEach((c) => c.remove());
      }, n.prototype.updateSelected = function(e) {
        this.selectedDot && (this.selectedDot.classList.remove("is-selected"), this.selectedDot.removeAttribute("aria-current")), this.dots.length && (this.selectedDot = this.dots[e], this.selectedDot.classList.add("is-selected"), this.selectedDot.setAttribute("aria-current", "step"));
      }, r.PageDots = n, Object.assign(r.defaults, {
        pageDots: !0
      }), r.create.pageDots = function() {
        this.options.pageDots && (this.pageDots = new n(), this.handlePageDotsClick = this.onPageDotsClick.bind(this), this.on("activate", this.activatePageDots), this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots));
      };
      let t = r.prototype;
      return t.activatePageDots = function() {
        this.pageDots.setDots(this.slides.length), this.focusableElems.push(...this.pageDots.dots), this.pageDots.holder.addEventListener("click", this.handlePageDotsClick), this.element.append(this.pageDots.holder);
      }, t.onPageDotsClick = function(e) {
        let o = this.pageDots.dots.indexOf(e.target);
        o !== -1 && (this.uiChange(), this.select(o));
      }, t.updateSelectedPageDots = function() {
        this.pageDots.updateSelected(this.selectedIndex);
      }, t.updatePageDots = function() {
        this.pageDots.dots.forEach((e) => {
          a.removeFrom(this.focusableElems, e);
        }), this.pageDots.setDots(this.slides.length), this.focusableElems.push(...this.pageDots.dots);
      }, t.deactivatePageDots = function() {
        this.pageDots.holder.remove(), this.pageDots.holder.removeEventListener("click", this.handlePageDotsClick);
      }, r.PageDots = n, r;
    });
  }(zt)), N;
}
var U = {}, Wt = {
  get exports() {
    return U;
  },
  set exports(d) {
    U = d;
  }
}, ot;
function Bt() {
  return ot || (ot = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(D()) : r(p.Flickity);
    })(typeof window < "u" ? window : S, function(r) {
      function a(t, e) {
        this.autoPlay = t, this.onTick = e, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind(this), this.onVisibilityPlay = this.visibilityPlay.bind(this);
      }
      a.prototype.play = function() {
        if (this.state === "playing")
          return;
        if (document.hidden) {
          document.addEventListener("visibilitychange", this.onVisibilityPlay);
          return;
        }
        this.state = "playing", document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick();
      }, a.prototype.tick = function() {
        if (this.state !== "playing")
          return;
        let t = typeof this.autoPlay == "number" ? this.autoPlay : 3e3;
        this.clear(), this.timeout = setTimeout(() => {
          this.onTick(), this.tick();
        }, t);
      }, a.prototype.stop = function() {
        this.state = "stopped", this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange);
      }, a.prototype.clear = function() {
        clearTimeout(this.timeout);
      }, a.prototype.pause = function() {
        this.state === "playing" && (this.state = "paused", this.clear());
      }, a.prototype.unpause = function() {
        this.state === "paused" && this.play();
      }, a.prototype.visibilityChange = function() {
        let t = document.hidden;
        this[t ? "pause" : "unpause"]();
      }, a.prototype.visibilityPlay = function() {
        this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay);
      }, Object.assign(r.defaults, {
        pauseAutoPlayOnHover: !0
      }), r.create.player = function() {
        this.player = new a(this.options.autoPlay, () => {
          this.next(!0);
        }), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer);
      };
      let n = r.prototype;
      return n.activatePlayer = function() {
        this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this));
      }, n.playPlayer = function() {
        this.player.play();
      }, n.stopPlayer = function() {
        this.player.stop();
      }, n.pausePlayer = function() {
        this.player.pause();
      }, n.unpausePlayer = function() {
        this.player.unpause();
      }, n.deactivatePlayer = function() {
        this.player.stop(), this.element.removeEventListener("mouseenter", this);
      }, n.onmouseenter = function() {
        this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this));
      }, n.onmouseleave = function() {
        this.player.unpause(), this.element.removeEventListener("mouseleave", this);
      }, r.Player = a, r;
    });
  }(Wt)), U;
}
var $ = {}, Mt = {
  get exports() {
    return $;
  },
  set exports(d) {
    $ = d;
  }
}, lt;
function _t() {
  return lt || (lt = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(
        D(),
        L()
      ) : r(
        p.Flickity,
        p.fizzyUIUtils
      );
    })(typeof window < "u" ? window : S, function(r, a) {
      function n(e) {
        let o = document.createDocumentFragment();
        return e.forEach((c) => o.appendChild(c.element)), o;
      }
      let t = r.prototype;
      return t.insert = function(e, o) {
        let c = this._makeCells(e);
        if (!c || !c.length)
          return;
        let u = this.cells.length;
        o = o === void 0 ? u : o;
        let s = n(c), h = o === u;
        if (h)
          this.slider.appendChild(s);
        else {
          let l = this.cells[o].element;
          this.slider.insertBefore(s, l);
        }
        if (o === 0)
          this.cells = c.concat(this.cells);
        else if (h)
          this.cells = this.cells.concat(c);
        else {
          let l = this.cells.splice(o, u - o);
          this.cells = this.cells.concat(c).concat(l);
        }
        this._sizeCells(c), this.cellChange(o), this.positionSliderAtSelected();
      }, t.append = function(e) {
        this.insert(e, this.cells.length);
      }, t.prepend = function(e) {
        this.insert(e, 0);
      }, t.remove = function(e) {
        let o = this.getCells(e);
        if (!o || !o.length)
          return;
        let c = this.cells.length - 1;
        o.forEach((u) => {
          u.remove();
          let s = this.cells.indexOf(u);
          c = Math.min(s, c), a.removeFrom(this.cells, u);
        }), this.cellChange(c), this.positionSliderAtSelected();
      }, t.cellSizeChange = function(e) {
        let o = this.getCell(e);
        if (!o)
          return;
        o.getSize();
        let c = this.cells.indexOf(o);
        this.cellChange(c);
      }, t.cellChange = function(e) {
        let o = this.selectedElement;
        this._positionCells(e), this._updateWrapShiftCells(), this.setGallerySize();
        let c = this.getCell(o);
        c && (this.selectedIndex = this.getCellSlideIndex(c)), this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex), this.emitEvent("cellChange", [e]), this.select(this.selectedIndex);
      }, r;
    });
  }(Mt)), $;
}
var H = {}, Tt = {
  get exports() {
    return H;
  },
  set exports(d) {
    H = d;
  }
}, ht;
function qt() {
  return ht || (ht = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(
        D(),
        L()
      ) : r(
        p.Flickity,
        p.fizzyUIUtils
      );
    })(typeof window < "u" ? window : S, function(r, a) {
      const n = "data-flickity-lazyload", t = `${n}-src`, e = `${n}-srcset`, o = `img[${n}], img[${t}], img[${e}], source[${e}]`;
      r.create.lazyLoad = function() {
        this.on("select", this.lazyLoad), this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
      };
      let c = r.prototype;
      c.lazyLoad = function() {
        let { lazyLoad: h } = this.options;
        if (!h)
          return;
        let l = typeof h == "number" ? h : 0;
        this.getAdjacentCellElements(l).map(u).flat().forEach((m) => new s(m, this.handleLazyLoadComplete));
      };
      function u(h) {
        if (h.matches("img")) {
          let l = h.getAttribute(n), m = h.getAttribute(t), y = h.getAttribute(e);
          if (l || m || y)
            return h;
        }
        return [...h.querySelectorAll(o)];
      }
      c.onLazyLoadComplete = function(h, l) {
        let m = this.getParentCell(h), y = m && m.element;
        this.cellSizeChange(y), this.dispatchEvent("lazyLoad", l, y);
      };
      function s(h, l) {
        this.img = h, this.onComplete = l, this.load();
      }
      return s.prototype.handleEvent = a.handleEvent, s.prototype.load = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this);
        let h = this.img.getAttribute(n) || this.img.getAttribute(t), l = this.img.getAttribute(e);
        this.img.src = h, l && this.img.setAttribute("srcset", l), this.img.removeAttribute(n), this.img.removeAttribute(t), this.img.removeAttribute(e);
      }, s.prototype.onload = function(h) {
        this.complete(h, "flickity-lazyloaded");
      }, s.prototype.onerror = function(h) {
        this.complete(h, "flickity-lazyerror");
      }, s.prototype.complete = function(h, l) {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this), (this.img.parentNode.matches("picture") ? this.img.parentNode : this.img).classList.add(l), this.onComplete(this.img, h);
      }, r.LazyLoader = s, r;
    });
  }(Tt)), H;
}
var X = {}, Ft = {
  get exports() {
    return X;
  },
  set exports(d) {
    X = d;
  }
}, j = {}, Ot = {
  get exports() {
    return j;
  },
  set exports(d) {
    j = d;
  }
};
/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
var at;
function Rt() {
  return at || (at = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(p, V()) : p.imagesLoaded = r(p, p.EvEmitter);
    })(
      typeof window < "u" ? window : S,
      function(r, a) {
        let n = r.jQuery, t = r.console;
        function e(l) {
          return Array.isArray(l) ? l : typeof l == "object" && typeof l.length == "number" ? [...l] : [l];
        }
        function o(l, m, y) {
          if (!(this instanceof o))
            return new o(l, m, y);
          let g = l;
          if (typeof l == "string" && (g = document.querySelectorAll(l)), !g) {
            t.error(`Bad element for imagesLoaded ${g || l}`);
            return;
          }
          this.elements = e(g), this.options = {}, typeof m == "function" ? y = m : Object.assign(this.options, m), y && this.on("always", y), this.getImages(), n && (this.jqDeferred = new n.Deferred()), setTimeout(this.check.bind(this));
        }
        o.prototype = Object.create(a.prototype), o.prototype.getImages = function() {
          this.images = [], this.elements.forEach(this.addElementImages, this);
        };
        const c = [1, 9, 11];
        o.prototype.addElementImages = function(l) {
          l.nodeName === "IMG" && this.addImage(l), this.options.background === !0 && this.addElementBackgroundImages(l);
          let { nodeType: m } = l;
          if (!m || !c.includes(m))
            return;
          let y = l.querySelectorAll("img");
          for (let g of y)
            this.addImage(g);
          if (typeof this.options.background == "string") {
            let g = l.querySelectorAll(this.options.background);
            for (let P of g)
              this.addElementBackgroundImages(P);
          }
        };
        const u = /url\((['"])?(.*?)\1\)/gi;
        o.prototype.addElementBackgroundImages = function(l) {
          let m = getComputedStyle(l);
          if (!m)
            return;
          let y = u.exec(m.backgroundImage);
          for (; y !== null; ) {
            let g = y && y[2];
            g && this.addBackground(g, l), y = u.exec(m.backgroundImage);
          }
        }, o.prototype.addImage = function(l) {
          let m = new s(l);
          this.images.push(m);
        }, o.prototype.addBackground = function(l, m) {
          let y = new h(l, m);
          this.images.push(y);
        }, o.prototype.check = function() {
          if (this.progressedCount = 0, this.hasAnyBroken = !1, !this.images.length) {
            this.complete();
            return;
          }
          let l = (m, y, g) => {
            setTimeout(() => {
              this.progress(m, y, g);
            });
          };
          this.images.forEach(function(m) {
            m.once("progress", l), m.check();
          });
        }, o.prototype.progress = function(l, m, y) {
          this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !l.isLoaded, this.emitEvent("progress", [this, l, m]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, l), this.progressedCount === this.images.length && this.complete(), this.options.debug && t && t.log(`progress: ${y}`, l, m);
        }, o.prototype.complete = function() {
          let l = this.hasAnyBroken ? "fail" : "done";
          if (this.isComplete = !0, this.emitEvent(l, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
            let m = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[m](this);
          }
        };
        function s(l) {
          this.img = l;
        }
        s.prototype = Object.create(a.prototype), s.prototype.check = function() {
          if (this.getIsImageComplete()) {
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            return;
          }
          this.proxyImage = new Image(), this.img.crossOrigin && (this.proxyImage.crossOrigin = this.img.crossOrigin), this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.proxyImage.src = this.img.currentSrc || this.img.src;
        }, s.prototype.getIsImageComplete = function() {
          return this.img.complete && this.img.naturalWidth;
        }, s.prototype.confirm = function(l, m) {
          this.isLoaded = l;
          let { parentNode: y } = this.img, g = y.nodeName === "PICTURE" ? y : this.img;
          this.emitEvent("progress", [this, g, m]);
        }, s.prototype.handleEvent = function(l) {
          let m = "on" + l.type;
          this[m] && this[m](l);
        }, s.prototype.onload = function() {
          this.confirm(!0, "onload"), this.unbindEvents();
        }, s.prototype.onerror = function() {
          this.confirm(!1, "onerror"), this.unbindEvents();
        }, s.prototype.unbindEvents = function() {
          this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
        };
        function h(l, m) {
          this.url = l, this.element = m, this.img = new Image();
        }
        return h.prototype = Object.create(s.prototype), h.prototype.check = function() {
          this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(this.img.naturalWidth !== 0, "naturalWidth"), this.unbindEvents());
        }, h.prototype.unbindEvents = function() {
          this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
        }, h.prototype.confirm = function(l, m) {
          this.isLoaded = l, this.emitEvent("progress", [this, this.element, m]);
        }, o.makeJQueryPlugin = function(l) {
          l = l || r.jQuery, l && (n = l, n.fn.imagesLoaded = function(m, y) {
            return new o(this, m, y).jqDeferred.promise(n(this));
          });
        }, o.makeJQueryPlugin(), o;
      }
    );
  }(Ot)), j;
}
var ct;
function Nt() {
  return ct || (ct = 1, function(d) {
    (function(p, r) {
      d.exports ? d.exports = r(
        D(),
        Rt()
      ) : r(
        p.Flickity,
        p.imagesLoaded
      );
    })(
      typeof window < "u" ? window : S,
      function(r, a) {
        return r.create.imagesLoaded = function() {
          this.on("activate", this.imagesLoaded);
        }, r.prototype.imagesLoaded = function() {
          if (!this.options.imagesLoaded)
            return;
          let n = (t, e) => {
            let o = this.getParentCell(e.img);
            this.cellSizeChange(o && o.element), this.options.freeScroll || this.positionSliderAtSelected();
          };
          a(this.slider).on("progress", n);
        }, r;
      }
    );
  }(Ft)), X;
}
/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */
(function(d) {
  if (d.exports) {
    const p = D();
    At(), It(), wt(), Bt(), _t(), qt(), Nt(), d.exports = p;
  }
})(ft);
const Ut = z, $t = /* @__PURE__ */ dt({
  __proto__: null,
  default: Ut
}, [z]);
export {
  $t as i
};
